import React from 'react'

import { useParams } from 'utils/hooks'
import { useReport } from 'redux/hooks/Reports'

import ReportTemplate from 'components_new/templates/ReportTemplate'

const ReportSettings = () => {
  const { id } = useParams<{ id: string }>()

  const report = useReport(id)

  // loading
  if (!report) return <></>

  // success
  return (
    <>
      <ReportTemplate>{'[SETTINGS]'}</ReportTemplate>
    </>
  )
}

export default ReportSettings
